import styled from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'

export const HomeWrapper = styled.div`
  
`

interface SubtitleProps {
  smallMargin?: boolean
}

export const Subtitle = styled.strong<SubtitleProps>`
  line-height: 35px;
  font-size: 16px;
  margin-bottom: ${(props) => props.smallMargin ? '4px' : '10px'};
  display: block;
`

export const HomeContent = styled.div`
  display: flex;
  
  @media (max-width: 800px) {
    flex-direction: column;
  }
`

export const HomeLeftPart = styled.div`
  margin-right: 17px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;

  @media (max-width: ${measures.mobileThreshold}px) {
    margin-right: 0;
  }
`

export const CenterDomiciliations = styled.div`
  & > div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 1285px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`

export const DomiciliationType = styled.div`
  position: relative;
  flex: 1;
  overflow: hidden;
  
  &:first-child {
    margin-left: 0;
  }

  @media (max-width: ${measures.mobileThreshold}px) {
    width: 100%;
  }
`

export const DomiciliationTypeContent = styled.div`
  background: white;
  min-width: 700px;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  overflow: hidden;
  
  & > img {
    width: 50px;
    margin-right: 16px;
  }
`

export const TypeDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;

  & > span {
    & > b {
      color: ${colors.waterBlue};
      margin-left: 10px;
    }
  }

  & > a {
    color: ${colors.darkGrey};
    font-weight: 600;
    text-decoration: underline;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      color: ${colors.darkGrey};
    }
  }
`

export const TypeNotification = styled.div`
  width: 12px;
  height: 12px;
  background: ${colors.reddishPink};
  border-radius: 6px;
  position: absolute;
  top: 0px;
  right: 16px;
`

export const CenterDetails = styled.div`
  max-width: 270px;
  background: white;
  border-radius: 4px;
  padding: 16px 24px 30px;
  margin-top: 39px;

  @media (max-width: 800px) {
    max-width: 100%;
    margin-right: 19px;
  }

  @media (max-width: ${measures.mobileThreshold}px) {
    max-width: 100%;
    margin-top: 30px;
    margin-right: 0px;
  }
`

export const CenterAddress = styled.div`
  border-bottom: 1px solid ${colors.lightGrey};
  margin-bottom: 17px;
  padding-bottom: 28px;
  
  & > span {
    line-height: 19px;
    color: ${colors.steelGrey};
  }
`

export const CenterOpeningHours = styled.div`
  & > ul {
    line-height: 22px;
    color: ${colors.steelGrey};
    padding: 0;
    margin: 0;
    list-style-type: none;
  }
`

export const ModifyOpeningHours = styled.a`
  line-height: 19px;
  color: ${colors.darkGrey};
  text-decoration: underline;
  margin-top: 28px;
  display: block;
  
  &:hover {
    color: ${colors.darkGrey};
  }
  
  & > svg {
    margin-left: 10px;
  }
`

export const ModifyOpeningHoursDialogContent = styled.div`
  padding-left: 7px;
  display: flex;
  flex-direction: column;
  
  & > b {
    line-height: 41px;
    font-size: 22px;
    margin-bottom: 10px;
  }

  @media (max-width: ${measures.mobileThreshold}px) {
    height: 100%;
    
    & .ant-input-wrapper {
      flex: 1;
      
      & > textarea {
        height: 100%;
      }
    }
  }
`

export const ModifyOpeningHoursDialogActions = styled.div`
  text-align: right;
  margin-top: 47px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  
  & > a {
    font-weight: 600;
    text-decoration: underline;
    margin-right: 40px;
  }
  
  & > div {
    width: 180px;
  }
  
  & > button {
    padding: 5.5px 40px;
  }

  @media (max-width: ${measures.mobileThreshold}px) {
    margin-top: 5px;
    
    & > a {
      display: none;
    }
    
    & > div {
      width: 100%;
    }
  }
`

export const OpeningHoursUpdatedContent = styled.div`
  width: 100%;
  max-width: 426px;
  padding: 88px 0 154px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  & > span {
    margin-top: 40px;
  }
  
  @media (max-width: ${measures.mobileThreshold}px) {
    height: 100%;
    padding: 0 0 59px;
  }
`
